import React, { useState } from 'react';
import { PageHero } from '../components/Sections';
import { galleryImages as fb } from '../data/mock';
import { useContent } from '../context/ContentContext';
import { Dialog, DialogContent } from '../components/ui/dialog';
import Seo from '../components/Seo';

const Gallery = () => {
  const { galleryImages = fb } = useContent();
  const [active, setActive] = useState(null);
  return (
    <div>
      <Seo
        title="HVAC Project Photos | Heating & AC Installations | Comfort Air Mechanical"
        description="Browse completed heating, cooling, ductwork and sheet metal projects by Comfort Air Mechanical across Cortez and the Four Corners area of Southwest Colorado."
        path="/gallery"
      />
      <PageHero title="Our Work" subtitle="A look at some of our completed heating & cooling projects across Southwest Colorado." crumb="Photos" />
      <section className="section-pad bg-white">
        <div className="container-c">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {galleryImages.map((img, i) => (
              <button key={i} onClick={() => setActive(img)} className="group relative rounded-2xl overflow-hidden shadow-sm hover-lift aspect-[4/3]">
                <img src={img.src} alt={img.caption} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-bluedeep/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-5">
                  <span className="text-white font-display font-semibold">{img.caption}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      <Dialog open={!!active} onOpenChange={() => setActive(null)}>
        <DialogContent className="max-w-3xl p-0 overflow-hidden bg-transparent border-0 shadow-none">
          {active && (
            <div className="relative">
              <img src={active.src} alt={active.caption} className="w-full rounded-xl" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-5 rounded-b-xl">
                <span className="text-white font-display font-semibold text-lg">{active.caption}</span>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Gallery;
